import { ApolloClient, gql } from 'apollo-boost';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { createHttpLink } from 'apollo-link-http';

const client = new ApolloClient({
  link: createHttpLink({
    uri: 'https://api.envolvetv.com.br/graphql', // TODO: get from env var 
    useGETForQueries: true
  }),
  cache: new InMemoryCache()
})

const newsQuery = gql`
query contentQuery(
  $limit: Int,
  $offset: Int
  $sort: [EntityQuerySortInput]
  $filter: EntityQueryFilterInput
) {
  news: nodeQuery(offset: $offset, limit: $limit, sort: $sort, filter: $filter) {
    count
    entities {
      ... on NodeNews {
        title
        topper: fieldTopper {
          entity {
            entityLabel
          }
        }
        photo: fieldMainImage {
          alt
          title
          derivative(style: TEASERIMAGESTYLE) {
            url
          }
        }
        url: entityUrl {
          ... on EntityCanonicalUrl {
            alias: pathAlias
          }
        }
      }
      ... on NodeArticleColumnist {
        title
        topper: fieldTopper {
          entity {
            entityLabel
          }
        }
        photo: fieldMainImage {
          alt
          title
          derivative(style: TEASERIMAGESTYLE) {
            url
          }
        }
        url: entityUrl {
          ... on EntityCanonicalUrl {
            alias: pathAlias
          }
        }
      }
    }
  }
}
`

const menuQuery = gql`
query HeaderMenu {
  topbar: menuByName(name: "menu-topbar") {
    links {
      ...MenuLink
      links {
        ...MenuLink
        links {
          ...MenuLink
        }
      }
    }
  }
  sidebar: menuByName(name: "sidebar-menu-nsc") {
    links {
      ...MenuLink
      links {
        ...MenuLink
        links {
          ...MenuLink
        }
      }
    }
  }
  socialMedias: menuByName(name: "social-medias-menu") {
    links {
      ...MenuLink
    }
  }
}
fragment MenuLink on MenuLink {
  label
  url {
    path
  }
}
`

export class GraphQLError extends Error {
  constructor(messages = []) {
    super(`GraphQL errors: ${messages.join(', ')}`);
    this.name = 'GraphQLError';
  }
}

export class NSCTotalService {

  static getNews(field_categories, offset, columnist) {
    return this.executeQuery(newsQuery, {
      "limit": 12,
      "offset": offset,
      "sort": [{ "field": "published_at", "direction": "DESC" }],
      "filter": {
        "conditions": [
          { "field": "status", "value": "1", "operator": "EQUAL"},
          { "field": "type", "value": ["news", columnist ? "article_columnist" : '' ], "operator": "IN"},
          { "field": "field_categories", "value": field_categories, "operator": "IN" }
        ]
      }
   });
  }

  static getMenus() {
    return this.executeQuery(menuQuery);
  }

  static async executeQuery(query, variables) {
    const result = await client.query({ query, variables });

    if (result.errors && result.errors.length) {
      console.error('GraphQL error', result.errors);
      const messages = result.errors.map(e => e.message);
      throw new GraphQLError(messages);
    }

    return result.data;
  }
}
